import { AppBar, Box, Tab, Tabs, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react"
import { useLocation, useParams, useSearchParams } from "react-router-dom"

import EditSponsor from "./EditSponsor"
import ServiceForm from "./ServiceForm"
import SwipeableViews from "react-swipeable-views"
import { BusinessOffersComponent } from "../BusinessOfferComponent"

const TAB_INDEX_BY_QUERY_VALUE: Record<string, number> = {
  detail: 0,
  services: 1,
  offers: 2,
}

function TabPanel(props: { [x: string]: any; children: any; value: any; index: any; }) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  )
}

function a11yProps(index: number) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  }
}

const SponsorTabs = ({ onSuccess }: any) => {
  const { id } = useParams()
  const { state } = useLocation()
  const [searchParams] = useSearchParams()
  const [data, setData] = useState()
  const [value, setValue] = useState(
    () => TAB_INDEX_BY_QUERY_VALUE[searchParams.get("tab") || ""] ?? 0,
  )
  const theme = useTheme()

  const handleChange = (event: any, newValue: React.SetStateAction<number>) => {
    setValue(newValue)
  }

  const handleChangeIndex = (index: React.SetStateAction<number>) => {
    setValue(index)
  }
  function reload() {
    //   getData({ path: `/businesses/${id}`, setData })
  }
  useEffect(() => {
    if (state?.id) {
      setData(state)
    } else {
      reload()
    }
  }, [id, state])

  return (
    <Box sx={{ bgcolor: "background.paper", width: "80vw" }}>
      <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="secondary"
          textColor="inherit"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab label="Sponsor Detail" {...a11yProps(0)} />
          <Tab label="Sponsor Services" {...a11yProps(1)} />
          <Tab label="Sponsor Offers" {...a11yProps(2)} />
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={value} index={0} dir={theme.direction}>
          <EditSponsor />
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          <ServiceForm />
        </TabPanel>
        <TabPanel value={value} index={2} dir={theme.direction}>
          {id ? <BusinessOffersComponent businessId={id} /> : null}
        </TabPanel>
      </SwipeableViews>
    </Box>
  )
}
export default SponsorTabs
